<template>
  <el-dialog
    title="添加供应商"
    :visible.sync="dialogVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="addForm"
      :model="addResourceSupplierInfo"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="供应商名称" prop="supplierName">
        <el-input
          v-model="addResourceSupplierInfo.supplierName"
          placeholder="必填，请填写供应商名称"
        />
      </el-form-item>
      <el-form-item label="供应商地址" prop="address">
        <el-input
          v-model="addResourceSupplierInfo.address"
          placeholder="必填，请填写供应商地址"
        />
      </el-form-item>
      <el-form-item label="供应商联系方式" prop="tel">
        <el-input
          v-model="addResourceSupplierInfo.tel"
          placeholder="必填，请填写供应商联系方式"
        />
      </el-form-item>
      <el-form-item label="联系人姓名" prop="contactName">
        <el-input
          v-model="addResourceSupplierInfo.contactName"
          placeholder="必填，请填写联系人姓名"
        />
      </el-form-item>
      <el-form-item label="开户行">
        <el-input
          v-model="addResourceSupplierInfo.accountBank"
          placeholder="选填，请填写开户行"
        />
      </el-form-item>
      <el-form-item label="开户行账号">
        <el-input
          v-model="addResourceSupplierInfo.bankAccountNumber"
          placeholder="选填，请填写开户行账号"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="addResourceSupplierInfo.remark"
          type="textarea"
          placeholder="选填，请填写备注"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="saveResourceSupplierInfo">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveResourceSupplier } from '@/api/goods/resourceSupplierApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddResourceSupplier',
  data() {
    return {
      dialogVisible: false,
      addResourceSupplierInfo: {
        supplierName: '',
        address: '',
        tel: '',
        contactName: '',
        accountBank: '',
        bankAccountNumber: '',
        remark: ''
      },
      rules: {
        supplierName: [
          { required: true, message: '供应商名称不能为空', trigger: 'blur' },
          { max: 255, message: '供应商名称太长', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '供应商地址不能为空', trigger: 'blur' },
          { max: 255, message: '供应商地址太长', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '供应商联系方式不能为空', trigger: 'blur' },
          { max: 11, message: '供应商联系方式太长', trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: '联系人姓名不能为空', trigger: 'blur' },
          { max: 255, message: '联系人姓名太长', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.addForm.resetFields()
      this.addResourceSupplierInfo = {
        supplierName: '',
        address: '',
        tel: '',
        contactName: '',
        accountBank: '',
        bankAccountNumber: '',
        remark: ''
      }
    },
    saveResourceSupplierInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          const params = {
            ...this.addResourceSupplierInfo,
            shopId: getShopId()
          }
          saveResourceSupplier(params)
            .then(response => {
              this.$message.success('添加成功')
              this.closeDialog()
              this.$emit('refresh')
            })
            .catch(error => {
              this.$message.error(error.message || '添加失败')
            })
        }
      })
    }
  }
}
</script>